import produce from 'immer';
import { setSegments, setSegmentDate, setAllSegmentsSelect, setSegmentSelect, clearSegmentsDate } from './actions';
const initialState = {};
function segmentsReducer(state = initialState, { type, payload }) {
    return produce(state, draft => {
        switch (type) {
            case setSegments.toString():
                return payload;
            case setAllSegmentsSelect.toString():
                const actionPayload = payload;
                Object.keys(draft).forEach(key => (draft[key].isSelected = actionPayload));
                break;
            case setSegmentSelect.toString(): {
                const actionPayload = payload;
                const isAllSegments = Object.values(draft).every(segment => segment.isSelected);
                if (isAllSegments) {
                    Object.keys(draft).forEach(key => (draft[key].isSelected = false));
                }
                draft[actionPayload.id].isSelected = isAllSegments || actionPayload.selected;
                break;
            }
            case setSegmentDate.toString(): {
                const actionPayload = payload;
                draft[actionPayload.id].selectedDate = actionPayload.date;
                break;
            }
            case clearSegmentsDate.toString():
                Object.keys(draft).forEach(key => (draft[key].selectedDate = undefined));
                break;
        }
    });
}
export default segmentsReducer;
